'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = performanceMiddleware;
/* eslint-disable no-console */

function performanceMiddleware() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var logger = opts.logger || console.log.bind(console, '[RELAY-NETWORK]');

  return function (next) {
    return function (req) {
      // get query name here, because `req` can be changed after `next()` call
      var query = req.relayReqType + ' ' + req.relayReqId;

      var start = new Date().getTime();

      return next(req).then(function (res) {
        var end = new Date().getTime();
        logger(query + ': ' + (end - start) + 'ms');
        return res;
      });
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-relay-network-layer/lib/middleware/perf.js
// module id = 1514
// module chunks = 0